import { render, staticRenderFns } from "./ExchangeRequest.vue?vue&type=template&id=789155ea&"
import script from "./ExchangeRequest.vue?vue&type=script&lang=js&"
export * from "./ExchangeRequest.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeRequest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports